import { render } from "./SmsCreditWidget.vue?vue&type=template&id=0fe7c566"
import script from "./SmsCreditWidget.vue?vue&type=script&lang=js"
export * from "./SmsCreditWidget.vue?vue&type=script&lang=js"

import "./SmsCreditWidget.vue?vue&type=style&index=0&id=0fe7c566&lang=css"

import exportComponent from "/var/www/service/service-cp-company/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__